<script lang="ts">
	import Head1 from "../atoms/Head1.svelte";
</script>

<Head1>
	<slot name="title"></slot>
</Head1>
<div class="text-sm mt-2">
	<slot name="subtitle"></slot>
</div>